var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-justify-center tw-mt-24"},[_c('div',{staticClass:"tw-flex tw-flex-col tw-items-center tw-w-64 tw-p-10 tw-bg-white tw-rounded tw-shadow"},[_c('img',{attrs:{"src":require("@/assets/img/logo/shield_black.svg")}}),_c('h3',{staticClass:"tw-pt-10 tw-text-lg tw-font-bold"},[_vm._v("Page Not Found")])])])
}]

export { render, staticRenderFns }